export default __webpack_public_path__ + "static/media/module-screen-on-computer.b7e68c0c.png";